
import { defineComponent, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  props: {
    position: {
      type: String,
      default: "", //absolute, fixed; default: absolute
    },
    anchor: {
      type: String,
      default: "", //top-left, top-right, bottom-left, bottom-right; default: top-right
    },
    color: {
      type: String,
      default: "",
    },
    backgroundcolor: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { t } = useI18n();
    const state = reactive({
      cookieDuration: 30,
      accessibilityVisible: false,
      accessibilityList: [
        {
          id: "sxa-black-white",
          icon: "icon-sxa-black-white",
          title: t("header.accessibility.blackAndWhite"),
          class: "sx-accessibility--black-white",
          active: false,
          cookieValue: true,
        },
        {
          id: "sxa-contrast",
          icon: "icon-sxa-black",
          title: t("header.accessibility.contrastDark"),
          class: "sx-accessibility--contrast",
          active: false,
          cookieValue: true,
        },
        {
          id: "sxa-contrast-white",
          icon: "icon-sxa-white",
          title: t("header.accessibility.contrastWhite"),
          class: "sx-accessibility--contrast-white",
          active: false,
          cookieValue: true,
        },
        {
          id: "sxa-animation-off",
          icon: "icon-sxa-flash",
          title: t("header.accessibility.stopMovement"),
          class: "sx-accessibility--animation-off",
          active: false,
          cookieValue: true,
        },
        {
          id: "sxa-readable-font",
          icon: "icon-sxa-font",
          title: t("header.accessibility.readableFont"),
          class: "sx-accessibility--readable-font",
          active: false,
          cookieValue: true,
        },
        {
          id: "sxa-underline-links",
          icon: "icon-sxa-link",
          title: t("header.accessibility.underlineLink"),
          class: "sx-accessibility--underline-links",
          active: false,
          cookieValue: true,
        },
      ],
      accessibilityFontList: [
        {
          id: "sxa-font",
          title: "A",
          class: "sx-accessibility--font",
          spanClass: "text-default",
          active: false,
          cookieValue: "1",
        },
        {
          id: "sxa-font-1",
          title: "A",
          class: "sx-accessibility--font",
          spanClass: "text-md",
          active: false,
          cookieValue: "1.1",
        },
        {
          id: "sxa-font-2",
          title: "A",
          class: "sx-accessibility--font",
          spanClass: "text-lg",
          active: false,
          cookieValue: "1.3",
        },
      ],
    });

    onMounted(() => {
      getAccessibilities();
      getFontSizeAccessibilities();
    });

    const onMenuToggleAction = () => {
      state.accessibilityVisible = !state.accessibilityVisible;
    };

    const onSetupAccessibilityMode = (index: number) => {
      state.accessibilityList[index].active =
        !state.accessibilityList[index].active;
      state.accessibilityList[index].active
        ? setCookie(
            state.accessibilityList[index].id,
            state.accessibilityList[index].cookieValue as any,
            state.cookieDuration
          )
        : removeCookie(state.accessibilityList[index].id);
      getAccessibilities();
      onMenuToggleAction();
    };

    const onChangeFontSizeClick = (index: number) => {
      state.accessibilityFontList[index].active =
        !state.accessibilityFontList[index].active;
      state.accessibilityFontList.map((e, i) => {
        if (index != i) e.active = false;
      });
      state.accessibilityFontList[index].active
        ? setCookie(
            "sxa-font",
            state.accessibilityFontList[index].cookieValue,
            state.cookieDuration
          )
        : removeCookie("sxa-font");
      onMenuToggleAction();
      window.location.reload();
    };

    const onRemoveAllCookiesClick = () => {
      state.accessibilityList.map((item) => {
        if (item.active) {
          removeCookie(item.id);
        }
      });
      removeCookie("sxa-font");
      onMenuToggleAction();
      window.location.reload();
    };

    function getAccessibilities() {
      let body = document.documentElement;
      state.accessibilityList.map((item) => {
        if (getCookie(item.id)) {
          item.active = true;
          body.classList.add(item.class);
        } else {
          if (body.classList.contains(item.class))
            body.classList.remove(item.class);
        }
      });
    }

    function getFontSizeAccessibilities() {
      let sxaFontCookie = getCookie("sxa-font");
      if (sxaFontCookie) {
        state.accessibilityFontList.map((item) => {
          if (item.cookieValue == sxaFontCookie) item.active = true;
        });
        if (parseFloat(sxaFontCookie) > 1) {
          changeTextSize(sxaFontCookie);
        }
      }
    }

    function changeTextSize(value: string) {
      if (value) {
        let textElements = document.querySelectorAll(
          "p,span,a,h1,h2,h3,h4,h5,h6"
        );
        [].forEach.call(textElements, function (e: any) {
          let currentFontSize = window.getComputedStyle(e).fontSize;
          e.style.fontSize =
            parseInt(currentFontSize) * parseFloat(value) + "px";
        });
      }
    }

    function setCookie(name: string, value: string, days: number) {
      let expires, date;
      if (days) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name: string) {
      var nameEQ = name + "=",
        ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }

    function removeCookie(name: string) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    return {
      t,
      state,
      onSetupAccessibilityMode,
      onRemoveAllCookiesClick,
      onChangeFontSizeClick,
      onMenuToggleAction,
    };
  },
});
